import {
  CLEAN_BENEFICIARIES,
  BENEFICIARY_TYPE,
  SHOW_MODAL_ADD_BENEFICIARIES,
  ADD_BENEFICIARY,
  UPDATE_BENEFICIARIES,
} from "../types/beneficiaries";

const initialState = {
  beneficiaryType: null,
  showModalAddBeneficiaries: false,
  beneficiaries: [],
};

const beneficiariesReducer = (state = initialState, action) => {
  switch (action.type) {
    case BENEFICIARY_TYPE:
      return {
        ...state,
        beneficiaryType: action.payload,
      };
    case SHOW_MODAL_ADD_BENEFICIARIES:
      return {
        ...state,
        showModalAddBeneficiaries: action.payload,
      };
    case ADD_BENEFICIARY:
      return {
        ...state,
        beneficiaries: [...state.beneficiaries, action.payload],
      };
    case UPDATE_BENEFICIARIES:
      return {
        ...state,
        beneficiaries: action.payload,
      };
    case CLEAN_BENEFICIARIES:
      return initialState;

    default:
      return state;
  }
};

export default beneficiariesReducer;
